"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_HISTORY_FILTER = exports.DEFAULT_ADDRESS_FILTER = void 0;
var _models = require("../models");
const DEFAULT_ADDRESS_FILTER = exports.DEFAULT_ADDRESS_FILTER = _models.DeliveryOptionsFilter.AllAddresses;
const DEFAULT_HISTORY_FILTER = exports.DEFAULT_HISTORY_FILTER = _models.DeliveryOptionsFilter.History;
